import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface DataGridProps {
  children: ReactNode;
  columns?: 1 | 2 | 3;
  className?: string;
}

export function DataGrid({ children, columns = 2, className }: DataGridProps) {
  return (
    <dl
      className={cn(
        'grid gap-x-4 gap-y-2',
        // Mobile: always 2 columns
        'grid-cols-2',
        // Desktop: respect columns prop
        columns === 1 && 'md:grid-cols-1',
        columns === 2 && 'md:grid-cols-2',
        columns === 3 && 'md:grid-cols-3',
        className,
      )}
    >
      {children}
    </dl>
  );
}
